'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosHeart = function IoIosHeart(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.5 6.3c5.4 0 9.5 3.3 9.5 9 0 2.4-1 5.6-3.2 8.2s-3.5 4.1-7.8 6.9-6.5 3.4-6.5 3.4-2.2-0.6-6.5-3.4-5.6-4.2-7.8-6.9-3.2-5.8-3.2-8.2c0-5.7 4.1-9 9.5-9 3 0 6.4 1.4 8 4.1 1.6-2.7 5-4.1 8-4.1z' })
        )
    );
};

exports.default = IoIosHeart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-heart.js
// module id = 2414
// module chunks = 0